import PASSWORD_TYPES from './password/types';
import CANCEL_ACCOUNT_TYPES from './cancel-account/types';

export default {
  ...PASSWORD_TYPES,
  ...CANCEL_ACCOUNT_TYPES,
};
